import { addHours, formatISO, parseISO } from 'date-fns';

// property expiration interval in hours.
const expirationInterval = process.env.PROPERTY_IS_EXPIRED;

/**
 * Creates the formatted activation date for a Property
 *
 * @param string | lastTouchedDate - The current activated or updated date in ISO 8601
 * @returns string | in ISO 8601
 */
export const createPropertyActivatedAt = (lastTouchedDate = null) => {
    // Created/Reactivated
    if (!lastTouchedDate) {
        return formatISO(new Date());
    }

    // Updated
    return lastTouchedDate;
};

/**
 * Creates the formatted expiration date for a Property
 *
 * @param string | lastTouchedDate - The current activated date in ISO 8601
 * @returns string | in ISO 8601
 */
export const createPropertyExpiredAt = (lastTouchedDate = null) => {
    let touchedDate = '';

    if (!lastTouchedDate) {
        touchedDate = createPropertyActivatedAt(lastTouchedDate);
    }

    return formatISO(addHours(parseISO(touchedDate), expirationInterval));
};
